import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { $host } from '@App/api'

function normalizeHeaders(h: any): Record<string,string> {
  if (!h) return {}
  if (h instanceof Headers) {
    const out: Record<string,string> = {}
    h.forEach((v, k) => out[k] = v)
    return out
  }
  return { ...h }
}

export const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const argsObj = typeof args === 'string'
    ? { url: args, method: 'GET', body: undefined, params: undefined, headers: undefined }
    : {
      method: 'GET',
      body: undefined,
      params: undefined,
      headers: undefined,
      ...args,
    }

  const { url, method, body, params, headers } = argsObj

  try {
    const response = await $host({
      url,
      method,
      data: body,
      params,
      headers: {
        ...normalizeHeaders(headers),
        'Content-Type': 'application/json',
      },
    })

    return { data: response.data }
  } catch (error: any) {
    return {
      error: {
        status: error.response?.status,
        data: error.response?.data || error.message,
      },
    }
  }
}